import { signOut } from "next-auth/react";
import { useQueryClient } from "@tanstack/react-query";
import { useStore } from "@store/index";
import { invalidateProfileQueries } from "@store/helpers/profile/invalidateProfileQueries";

const useSignOut = () => {
    const clearWishlist = useStore((state) => state.clearWishlist);
    const setIsLoggedIn = useStore((state) => state.setIsLoggedIn);
    const clearMe = useStore((state) => state.clearMe);
    const queryClient = useQueryClient();

    function signOutHandler() {
        clearWishlist();
        clearMe();
        setIsLoggedIn(false);
        signOut({ redirect: false });

        invalidateProfileQueries(queryClient);
    }

    return { signOut: signOutHandler };
};

export default useSignOut;
